import { TextField } from "@mui/material";
import { useState } from "react";

interface Props {
  val: number;
  options?: any;
  row: any;
  colKey: string;
  onChange: (item: any, options?: any) => void;
}
export default function Percent({ val, options, colKey, row, onChange }: Props) {
  const [value, setValue] = useState(!!val ? val : options && options.defaultValue);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
        direction: "ltr",
      }}
    >
      <div style={{ height: 8, width: "100%", borderRadius: 8, backgroundColor: "#D9D9D9" }}>
        <div style={{ height: 8, width: `${value}%`, borderRadius: 8, backgroundColor: "#1062D0" }}></div>
      </div>
      <div>{value}%</div>
    </div>
  );
}
